import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);
  return (
    <div data-testid="services-page" className="bg-[#F5EFE4]">
      <section className="pt-40 pb-16 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <p className="overline">Our Services</p>
          <h1 className="font-serif text-5xl lg:text-7xl mt-4 leading-[1.02] text-[#1A1815]">A House of Eight Disciplines</h1>
          <div className="mt-6 flex justify-center"><span className="divider-gold-center" /></div>
          <p className="mt-6 text-[#6B665E]">Book any service as a single engagement or arrange it on retainer. Contact the concierge for bespoke combinations.</p>
        </div>
      </section>
      <section className="pb-24 max-w-[1400px] mx-auto px-6 lg:px-10 space-y-16">
        {services.map((s, i) => (
          <article key={s.slug} data-testid={`service-row-${s.slug}`} className={`grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10 items-center ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
            <div className="md:col-span-6"><img src={s.image} alt={s.name} className="w-full h-[320px] md:h-[420px] object-cover" /></div>
            <div className="md:col-span-5 md:col-start-8">
              <p className="overline">Discipline · {String(i + 1).padStart(2, "0")}</p>
              <h2 className="font-serif text-4xl lg:text-5xl mt-3 text-[#1A1815]">{s.name}</h2>
              <p className="text-[#6B665E] mt-4 leading-relaxed">{s.description}</p>
              <ul className="mt-6 divide-y divide-black/10 border-y border-black/10">
                {s.packages.map((p) => {
                  const u = (p.unit || "").trim();
                  const isFrom = u.toLowerCase().startsWith("from");
                  const isQuote = u.toLowerCase().startsWith("quote");
                  const isComp = u.toLowerCase().startsWith("complimentary");
                  const suffix = isFrom ? u.slice(4).trim().replace(/^·\s*/, "") : u;
                  return (
                    <li key={p.id} className="flex justify-between py-3 text-sm">
                      <span className="text-[#1A1815]">{p.name}</span>
                      <span className="text-[#C5A059] font-medium">
                        {isQuote ? (
                          <span>Quote on request</span>
                        ) : isComp ? (
                          <span>Complimentary <span className="text-[#6B665E] text-xs">for members</span></span>
                        ) : (
                          <>
                            {isFrom && <span className="text-[#6B665E] text-xs mr-1">From</span>}
                            £{p.price.toLocaleString()}
                            {suffix && !isFrom && <span className="text-[#6B665E] text-xs ml-1">{suffix}</span>}
                            {isFrom && suffix && <span className="text-[#6B665E] text-xs ml-1">· {suffix}</span>}
                          </>
                        )}
                      </span>
                    </li>
                  );
                })}
              </ul>
              <div className="mt-8 flex gap-4 flex-wrap">
                <Link to={`/services/${s.slug}`} className="luxor-btn-outline-dark" data-testid={`service-detail-${s.slug}`}>Details <ArrowRight size={13} /></Link>
                <Link to={`/book?service=${s.slug}`} className="luxor-btn-primary" data-testid={`service-book-${s.slug}`}>Reserve</Link>
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
